import axios from "axios";

const api = axios.create({
  baseURL: "https://streak-onboarding.el.r.appspot.com/nfo", // Replace with your API base URL
});

export default api;
